import { Alert, Link, Typography } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';
import { CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';
import { IGetConfirmationResponse } from '@lib/types';
import { getAwsDomainUrl } from '../../utils/generateURL';

export const AutoPayFailedAlert: React.FC = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const [confirmation] = useGlobalState('confirmation');

  const {
    currentBillPlan,
    updatedBillPlan,
    paymentDetails = {} as IGetConfirmationResponse['paymentDetails'],
  } = confirmation!;
  const { autoPaySuccessful, isAutoPayRequested } = paymentDetails || {};
  const billPlan = updatedBillPlan !== currentBillPlan ? updatedBillPlan : currentBillPlan;
  const enrolledInAutoPay = billPlan !== CurrentPayPlan.RECURRINGMONTHLY && isAutoPayRequested;
  const autoPayFailed = enrolledInAutoPay && !autoPaySuccessful;

  const autoPayLink = `${getAwsDomainUrl(window.location.hostname)}/payments/manage-autopay?memcid=${
    memberDetails?.sessionId
  }`;

  return autoPayFailed ? (
    <Alert severity="error" id="auto-pay-failed-alert" displayCloseButton={false} sx={{ marginTop: '1rem' }}>
      <Typography component="span" variant={'b2Regular'}>
        Sorry, we encountered an issue and could not complete your Auto Pay enrollment.{' '}
        <Link className="manage-autopay-link" target="_blank" href={autoPayLink}>
          <Typography component="span" variant={'b2Regular'} color="#0156A3">
            Manage Auto Pay.
          </Typography>
        </Link>
      </Typography>
    </Alert>
  ) : (
    <></>
  );
};
